export default {"src":"/_next/static/media/WEN.b9ff0b64.svg","height":18,"width":18};